<template>

<app-view-sheet-field align="center" :is-sticky="isSticky" :field="field" :filter="filter">

	{{ value }}

</app-view-sheet-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky'],

	computed: {

		value: function() {

			var contextual = (this.item.context) ? this.item.context : this.item
            
            return this.$_.keys(contextual.users.played).length

        }

	}

}

</script>

<style scoped>

</style>